import {useSelector} from 'react-redux';
import {EqualHeightElement} from 'react-equal-height';

import authenticationService from '../../../../services/authentication/AuthenticationService';

import SuggestedRelationships from '../../../SuggestedRelationships';

import {useCustomStore} from './CollectorSectionStore';
import SmallStat from './smallStat';
import SubcontractorStats from './subcontractorStats';
import Invitations from './invitations';

function CollectorSectionView() {
  const organisation = useSelector(globalState => globalState.organisation);
  const {state} = useCustomStore();
  const isExplorer = authenticationService.roles().isExplorer();
  const smallStats = ['users', 'projects'];

  let statsClasses = 'd-none d-lg-block col-12 col-lg-6 mt-lg-5';
  let invitationClasses = 'col-12 col-lg-6 order-first';
  let smallStatsClasses = 'col-12 col-lg-4';

  if (organisation.depositor && !isExplorer) {
    smallStats.push('clients');

    statsClasses = 'd-none d-lg-block col-12';
    invitationClasses = 'col-12 mt-lg-5';
    smallStatsClasses = 'col-12 col-lg-4 d-lg-flex flex-column justify-content-between';
  }

  return (
    <div className="row">
      <div className={statsClasses}>
        <div className="row">
          <div className={smallStatsClasses}>
            {smallStats.map((stat, index) => (
              <div
                key={`stat-${stat}`}
                className={index === 0 ? '' : 'mt-3'}
              >
                <SmallStat
                  label={stat}
                  stat={state[stat]}
                />
              </div>
            ))}
          </div>
          <div className="col-12 col-lg-8">
            <EqualHeightElement name="DashboardStats">
              <SubcontractorStats
                stats={state.subcontractors}
              />
            </EqualHeightElement>
          </div>
        </div>
      </div>
      <div className={invitationClasses}>
        <Invitations/>
        <SuggestedRelationships/>
      </div>
    </div>
  );
}

export default CollectorSectionView;
